var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29058 1.72996C9.49624 0.290351 13.1643 0.655977 16.0372 2.37848L17.6162 0.33275L20.7243 7.83992L12.4313 7.00992L13.9935 5.01188C12.1335 4.02662 9.84194 3.85553 7.82258 4.74969C5.53421 5.76305 4.18137 7.8895 4.05405 10.1567L0.595762 9.83899C0.795315 6.41431 2.85805 3.24987 6.29058 1.72996ZM7.88475 16.3739C9.60463 17.3092 11.747 17.4271 13.6585 16.4946L13.6585 16.4946C15.8248 15.4378 17.1632 13.3062 17.3103 11.0461L20.5424 11.283C20.2782 14.6847 18.2748 17.87 15.0254 19.4553C11.9905 20.9557 8.56318 20.6759 5.91138 19.0321L4.3861 21.0971L1.64453 13.7206L9.39301 14.3566L7.88475 16.3739Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFlip);
export default __webpack_public_path__ + "static/media/camera-flip.35ec2e7f731be7357d3e8879036ff471.svg";
export { ForwardRef as ReactComponent };